import React from "react";
import Select from "react-select";
import { Button } from "aible";
import moment from "moment";

import BlueprintTile from "components/Tiles/BlueprintTile.js";
import DatasetTile from "components/Tiles/DatasetTile";
import ProjectTile from "components/ConsultingProjects/ProjectTile";
import { Divider, TypeIcon } from "components/Home/Utils/Utils";
import getStyles from "components/Home/Utils/getStyles";

import { PROGRESS_STAGES } from "containers/ConsultingProjects/reducer";

import styles from "./style.module.css";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faUser,
  faCrown,
  faTimes,
  faClipboardCheck,
  faHourglassHalf,
  faUserClock,
  faExclamationTriangle
} from "@fortawesome/free-solid-svg-icons";

const CONSULTING_PRICE_MODIFIERS = [
  { value: "", label: "One Time Charge" },
  { value: "/month", label: "Per Month" }
];

const CONSULTING_PRICE_CONDITIONALS = [
  { value: "", label: "When the project is completed" },
  { value: "if results improve by >1%", label: "If you improve the resulting model by more than 1%" }
];

export default class ConsultingProjects extends React.Component {
  state = {
    selectedProject: null,
    show: false
  };

  createSelectProjectHandler(consult = null) {
    const drawerRef = this.refs.consultingDrawer;
    return () => {
      if (
        !consult ||
        (this.state.show && parseInt(this.state.selectedProject.id) === parseInt(consult && consult.id))
      ) {
        this.props.clearProject();
        return this.setState({
          selectedProject: null,
          show: false
        });
      } else {
        this.props.selectProject(consult.id);
        return this.setState({
          selectedProject: consult,
          show: Boolean(consult)
        });
      }
    };
  }

  render() {
    const {
      consulting,
      isAuthor,
      getConsultingBPs,
      getConsultingData,
      progressConsultingProject,
      cancelConsultingProject
    } = this.props;
    const { selectedProject, show } = this.state;
    const consultantActive =
      selectedProject && selectedProject.created_by && isAuthor(parseInt(selectedProject.created_by.id));
    return (
      <div className={styles.consultingProjectsWrapper}>
        <div className={styles.consultingProjects}>
          {<ProjectTile isFirst />}
          <div className={styles.consultingTiles}>
            {Object.values(consulting).map((elem) =>
              elem && elem.wizard && elem.wizard.marketplace && elem.wizard.marketplace.purchased ? (
                <ProjectTile
                  key={elem.id}
                  project={elem}
                  onClick={this.createSelectProjectHandler(elem)}
                  isHighlight={selectedProject && selectedProject.id === elem.id}
                  consultantActive={elem.created_by && isAuthor(parseInt(elem.created_by.id))}
                />
              ) : (
                ""
              )
            )}
          </div>
        </div>
        <div
          className={styles.consultingProjectsDrawerWrapper + (show ? "" : " " + styles.consultingProjectsDrawerHide)}
          ref="consultingDrawer"
        >
          {selectedProject && selectedProject.wizard && selectedProject.wizard.project ? (
            <div className={styles.consultingProjectsDrawer}>
              <ProjectsDrawerHeader
                {...this.props}
                name={selectedProject.wizard.project.name}
                time={moment.utc(selectedProject.created_date).local().fromNow()}
                commissioner={selectedProject.wizard.project.commissioner}
                consultant={selectedProject.created_by.fullname}
                price={selectedProject.wizard.project.price}
                priceModifier={selectedProject.wizard.project.priceModifier}
                priceConditional={selectedProject.wizard.project.priceConditional}
                costLimit={selectedProject.wizard.project.costLimit}
                sizeLimit={selectedProject.wizard.project.sizeLimit}
                status={selectedProject.wizard.project.status}
                description={selectedProject.wizard.project.description}
                availableBlueprints={getConsultingBPs(
                  selectedProject.wizard.project.links && selectedProject.wizard.project.links.blueprints
                )}
                availableData={getConsultingData(
                  selectedProject.wizard.project.links && selectedProject.wizard.project.links.data
                )}
                closeDrawerHandler={this.createSelectProjectHandler()}
                consultantActive={consultantActive}
              />
              <ProjectsDrawerFooter
                status={selectedProject.wizard.project.status}
                consultantActive={consultantActive}
                acceptHandler={() => {
                  progressConsultingProject(selectedProject.id, PROGRESS_STAGES.inProgress);
                  this.setState({ show: false });
                }}
                rejectHandler={() => {
                  cancelConsultingProject(selectedProject.id);
                  this.setState({ show: false });
                }}
                completeHandler={() => {
                  progressConsultingProject(selectedProject.id, PROGRESS_STAGES.complete);
                  this.setState({ show: false });
                }}
                cancelHandler={() => {
                  cancelConsultingProject(selectedProject.id);
                  this.setState({ show: false });
                }}
                approveHandler={() => {
                  cancelConsultingProject(selectedProject.id);
                  this.setState({ show: false });
                }}
                disputeHandler={() => {
                  progressConsultingProject(selectedProject.id, PROGRESS_STAGES.inDispute);
                  this.setState({ show: false });
                }}
              />
            </div>
          ) : (
            ""
          )}
        </div>
      </div>
    );
  }
}

class ProjectsDrawerHeader extends React.PureComponent {
  render() {
    const {
      name,
      commissioner,
      consultant,
      time,
      price,
      priceModifier,
      priceConditional,
      costLimit,
      sizeLimit,
      description,
      consultantActive,
      status,
      availableBlueprints,
      availableData,
      updateDatasetId,
      updateStep,
      history,
      limitData,
      closeDrawerHandler,
      getBlueprintData
    } = this.props;
    return (
      <div className={styles.drawerHeader}>
        <ProjectsDrawerTitle name={name} closeDrawerHandler={closeDrawerHandler} />
        <ProjectsDrawerStatus
          time={time}
          status={status}
          commissioner={commissioner}
          consultant={consultant}
          consultantActive={consultantActive}
          price={price}
          priceModifier={priceModifier}
          priceConditional={priceConditional}
        />

        <p>Description:</p>
        <h1>{description}</h1>
        <Divider margin={"15px 0px"} />
        <p>Available Resources:</p>
        <div className={styles.drawerHeaderLimitations}>
          <ProjectLimitationGraph label={"Cost Limit"} value={costLimit || 0} prefix={"$"} />
          <ProjectLimitationGraph label={"Upload Limit"} value={sizeLimit || 0} suffix={"Mb"} />
        </div>
        {availableBlueprints.length || availableData.length ? (
          <div style={{ marginLeft: "10px", marginTop: "8px" }}>
            <ProjectsDrawerConnections {...this.props} />
          </div>
        ) : (
          ""
        )}
      </div>
    );
  }
}

class ProjectsDrawerTitle extends React.PureComponent {
  render() {
    const { name, closeDrawerHandler } = this.props;
    const headerStyles = getStyles("consulting");
    return (
      <div className={styles.drawerTitle}>
        <h1>{name}</h1>
        <div className={styles.drawerTitleImage}>
          {headerStyles.image && <img src={headerStyles.image} alt={"Consulting"} />}
        </div>
        <div className={styles.drawerClose} onClick={closeDrawerHandler}>
          <FontAwesomeIcon icon={faTimes} />
        </div>
      </div>
    );
  }
}

class ProjectsDrawerStatus extends React.PureComponent {
  render() {
    const { time, status, commissioner, consultant, consultantActive, price, priceModifier, priceConditional } =
      this.props;
    let statusStyle;
    switch (status) {
      case PROGRESS_STAGES.complete:
        statusStyle = styles.completedStatus;
        break;
      case PROGRESS_STAGES.inDispute:
        statusStyle = styles.errorStatus;
        break;
      default:
        statusStyle = styles.inProgressStatus;
    }
    return (
      <div className={styles.drawerStatusWrapper}>
        <div className={styles.peopleDisplay}>
          {consultantActive ? (
            <div className={styles.drawerHeaderUserItem}>
              <div className={styles.drawerHeaderUserIcon}>
                <FontAwesomeIcon icon={faCrown} />
              </div>
              <h1>Project Owner:</h1>
              <h2>{commissioner}</h2>
            </div>
          ) : (
            ""
          )}
          {!consultantActive ? (
            <div className={styles.drawerHeaderUserItem}>
              <div className={styles.drawerHeaderUserIcon}>
                <FontAwesomeIcon icon={faUser} />
              </div>
              <h1>Consultant:</h1>
              <h2>{consultant}</h2>
            </div>
          ) : (
            ""
          )}
          <div className={styles.drawerHeaderPrice}>
            <h1>{price ? "$" + price + (priceModifier || "") : "Free"}&nbsp;</h1>
            {priceConditional ? <h2>{priceConditional}</h2> : ""}
          </div>
        </div>
        <div style={{ flexGrow: 1 }}></div>
        <div className={styles.drawerProgressWrapper}>
          <ProgressIcon status={status} size={"32px"} />
          <div className={styles.drawerProgress}>
            <h1 className={statusStyle}>{"Status: " + status}</h1>
            <h2>{"Last updated " + time}</h2>
          </div>
        </div>
      </div>
    );
  }
}

class ProjectLimitationGraph extends React.PureComponent {
  render() {
    const { label, value, prefix, suffix } = this.props;
    return (
      <div className={styles.graphWrapper}>
        <h1>{label + ":"}</h1>
        <div className={styles.barGraph}>
          <div className={styles.barGraphBar} style={{ width: value ? "99%" : "0px" }} />
          <p>{value ? "100%" : "0%"}</p>
        </div>
        <p>{(prefix || "") + value + (suffix || "") + " remaining"}</p>
      </div>
    );
  }
}
class ProjectsDrawerConnections extends React.PureComponent {
  createDataHandler(dataID) {
    const { consultantActive, updateDatasetId, updateStep, history, status, limitData } = this.props;
    if (!consultantActive)
      return () => {
        console.log("you are not the consultant");
      };
    return () => {
      if (status === PROGRESS_STAGES.inProgress) {
        updateDatasetId(dataID);
        updateStep(1);
        limitData();
        history.push("/create/new");
      }
    };
  }

  createBlueprintHandler(bpID) {
    const { consultantActive, history, status, limitData } = this.props;
    if (!consultantActive)
      return () => {
        console.log("you are not the consultant");
      };
    return () => {
      if (status === PROGRESS_STAGES.inProgress) {
        limitData();
        history.push("/blueprint/" + bpID);
      }
    };
  }

  render() {
    const { status, availableBlueprints, availableData, consultantActive, getBlueprintData } = this.props;
    return (
      <div>
        <div className={styles.displayResources}>
          {availableBlueprints &&
            availableBlueprints.map((bp) =>
              bp ? (
                <BlueprintTile
                  key={bp.id}
                  blueprint={bp}
                  dataset={getBlueprintData(bp.id)}
                  hideDelete
                  onClick={consultantActive ? this.createBlueprintHandler(bp.id) : false}
                />
              ) : (
                ""
              )
            )}
          {availableData &&
            availableData.map((data) =>
              data ? (
                <DatasetTile
                  key={data.id}
                  dataset={data}
                  hideDelete
                  onClick={consultantActive ? this.createDataHandler(data.id) : false}
                />
              ) : (
                ""
              )
            )}
        </div>
      </div>
    );
  }
}

class ProjectsDrawerFooter extends React.PureComponent {
  render() {
    const {
      status,
      consultantActive,
      acceptHandler,
      rejectHandler,
      completeHandler,
      cancelHandler,
      approveHandler,
      disputeHandler
    } = this.props;
    return (
      <div className={styles.drawerFooter}>
        {status === PROGRESS_STAGES.pendingAcceptance ? (
          consultantActive ? (
            <React.Fragment>
              <Button onClick={acceptHandler} type={"primary"} className={styles.drawerFooterButton}>
                Accept Project
              </Button>
              <Button onClick={rejectHandler} type={"secondary"} className={styles.drawerFooterButton}>
                Reject Project
              </Button>
            </React.Fragment>
          ) : (
            <Button onClick={cancelHandler} type={"secondary"} className={styles.drawerFooterButton}>
              Cancel Project
            </Button>
          )
        ) : (
          ""
        )}
        {status === PROGRESS_STAGES.inProgress ? (
          consultantActive ? (
            <React.Fragment>
              <Button onClick={cancelHandler} type={"secondary"} className={styles.drawerFooterButton}>
                Cancel Project
              </Button>
              <Button onClick={completeHandler} type={"primary"} className={styles.drawerFooterButton}>
                Complete Project
              </Button>
            </React.Fragment>
          ) : (
            <Button onClick={cancelHandler} type={"secondary"} className={styles.drawerFooterButton}>
              Cancel Project
            </Button>
          )
        ) : (
          ""
        )}
        {status === PROGRESS_STAGES.complete ? (
          consultantActive ? (
            <Button disabled type={"secondary"} className={styles.drawerFooterButton}>
              Awaiting Approval
            </Button>
          ) : (
            <React.Fragment>
              <Button onClick={disputeHandler} type={"secondary"} className={styles.drawerFooterButton}>
                Dispute Completion
              </Button>
              <Button onClick={approveHandler} type={"primary"} className={styles.drawerFooterButton}>
                Approve Completion
              </Button>
            </React.Fragment>
          )
        ) : (
          ""
        )}
        {status === PROGRESS_STAGES.inDispute ? (
          <Button disabled type={"secondary"} className={styles.drawerFooterButton}>
            Awaiting Dispute Resolution
          </Button>
        ) : (
          ""
        )}
      </div>
    );
  }
}

class ConsultingTitleTile extends React.PureComponent {
  render() {
    return (
      <div className={styles.tileWrapper}>
        <div className={styles.tile}>
          <h1>Projects</h1>
        </div>
      </div>
    );
  }
}

class ConsultingTile extends React.PureComponent {
  render() {
    const { selected, consulting, onClick, consultantActive } = this.props;
    const status = consulting && consulting.wizard && consulting.wizard.project && consulting.wizard.project.status;
    let statusStyle;
    switch (status) {
      case PROGRESS_STAGES.complete:
        statusStyle = styles.completedStatus;
        break;
      case PROGRESS_STAGES.inDispute:
        statusStyle = styles.errorStatus;
        break;
      default:
        statusStyle = styles.inProgressStatus;
    }
    return (
      <div className={styles.tileWrapper} onClick={onClick}>
        <div className={styles.tile + " " + styles.tileHover + (selected ? " " + styles.tileHighlight : "")}>
          <div className={styles.cardHeader}>
            <ProgressIcon
              status={consulting && consulting.wizard && consulting.wizard.project && consulting.wizard.project.status}
            />
            <div className={styles.cardHeaderTitle}>
              <h1>{consulting && consulting.wizard && consulting.wizard.project && consulting.wizard.project.name}</h1>
              <h2>{consulting && moment.utc(consulting.updated_date).local().fromNow()}</h2>
            </div>
          </div>
          <div className={styles.cardBody}>{status ? <h1 className={statusStyle}>{status}</h1> : ""}</div>
          {consultantActive ? (
            <div className={styles.cardHeaderAuthor}>
              <FontAwesomeIcon icon={faCrown} className={styles.cardHeaderIcon} />
              <p>
                {consulting && consulting.wizard && consulting.wizard.project && consulting.wizard.project.commissioner}
              </p>
            </div>
          ) : (
            ""
          )}
          {!consultantActive ? (
            <div className={styles.cardHeaderAuthor}>
              <FontAwesomeIcon icon={faUser} className={styles.cardHeaderIcon} />
              <p>{consulting && consulting.created_by && consulting.created_by.fullname}</p>
            </div>
          ) : (
            ""
          )}
          <TileConnections
            links={
              (consulting && consulting.wizard && consulting.wizard.project && consulting.wizard.project.links) || {}
            }
          />
        </div>
      </div>
    );
  }
}

export class ProgressIcon extends React.PureComponent {
  render() {
    const { status, size, colorClass, margin } = this.props;
    let iconDetails = {};
    switch (status) {
      case PROGRESS_STAGES.pendingAcceptance:
        iconDetails.image = faHourglassHalf;
        iconDetails.style = styles.inProgressStatus;
        break;
      case PROGRESS_STAGES.inProgress:
        iconDetails.image = faUserClock;
        iconDetails.style = styles.inProgressStatus;
        break;
      case PROGRESS_STAGES.complete:
        iconDetails.image = faClipboardCheck;
        iconDetails.style = styles.completedStatus;
        break;
      case PROGRESS_STAGES.inDispute:
        iconDetails.image = faExclamationTriangle;
        iconDetails.style = styles.errorStatus;
        break;
    }
    return (
      <div
        className={styles.progressIcon + " " + (colorClass ? colorClass : iconDetails.style)}
        style={
          size
            ? {
                fontSize: size,
                marginRight: margin ? margin : "6px"
              }
            : {}
        }
      >
        <FontAwesomeIcon icon={iconDetails.image} />
      </div>
    );
  }
}

class TileConnections extends React.PureComponent {
  render() {
    const { links } = this.props;
    const linksArr = Object.keys(links)
      .map((key) => ({
        type: key,
        num: links[key].length
      }))
      .filter((elem) => elem.num && elem.num > 0);
    return (
      <div className={styles.cardConnections}>
        {linksArr.length > 0 && <Divider margin={"3px 0px"} />}
        <div className={styles.cardConnectionsWrapper}>
          {linksArr.map((elem, i) => (elem.num > 0 ? <TypeIcon key={i} border type={elem.type} num={elem.num} /> : ""))}
        </div>
      </div>
    );
  }
}
